import * as tslib_1 from "tslib";
/* I94 in DS */
import React from 'react';
import IconWrap from '../IconWrap';
var AddCircle = function (props) { return (React.createElement(IconWrap, tslib_1.__assign({}, props),
    React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", width: "24", height: "24", viewBox: "-293 385 24 24" },
        React.createElement("circle", { cx: "-281", cy: "397", r: "8.5", fill: "none", stroke: "currentColor", strokeWidth: "2" }),
        React.createElement("path", { d: "M-280.2,397.8v3.3h-1.7v-3.3h-3.3v-1.7h3.3v-3.3h1.7v3.3h3.3v1.7H-280.2z", fill: "currentColor" })))); };
export default AddCircle;
//# sourceMappingURL=AddCircle.js.map